import api from '../api/api';
import { Cliente } from './ClienteFacade';

const API_URL = '/api/v1';

export interface Contrato {
    id: number;
    numeroContrato: string;
    objeto: string;
    status: string;
    dataInicio: string;
    dataFim: string;
    valorTotal: number;
    cliente: Cliente;
}

export interface ContratoDTO {
    numeroContrato: string;
    objeto: string;
    status: string;
    dataInicio: string;
    dataFim: string;
    valorTotal: number;
    clienteId: number;
}

export class ContratoFacade {
    static async listarTodos(): Promise<Contrato[]> {
        const response = await api.get(`${API_URL}/contratos`);
        if (response.data && Array.isArray(response.data.content)) {
            return response.data.content;
        }
        return Array.isArray(response.data) ? response.data : [];
    }

    static async criar(dados: ContratoDTO): Promise<Contrato> {
        const response = await api.post(`${API_URL}/contratos`, dados);
        return response.data;
    }

    static async atualizar(id: number, dados: ContratoDTO): Promise<Contrato> {
        const response = await api.put(`${API_URL}/contratos/${id}`, dados);
        return response.data;
    }

    static async excluir(id: number): Promise<void> {
        await api.delete(`${API_URL}/contratos/${id}`);
    }
}